import { isFlagEnabled } from "js/utilities";
import { updatePaymentProfileApi } from "./updatePaymentProfileApi";
import { UpdatePaymentProfile } from "./UpdatePaymentProfile";

export default isFlagEnabled("ENABLE_RECURRING_PAYMENTS")
  ? updatePaymentProfileApi
  : UpdatePaymentProfile;
